const SELECTORS = {
  card: ".js-post-card-sns-user-mute",
  info: ".js-post-card-sns-user-mute-info",
  caption: ".js-post-card-sns-user-mute-caption",
  content: ".js-post-card-sns-user-mute-content",
  unmuteCardButton: ".js-post-card-sns-user-mute-unmute-card-btn",
  muteCardButton: ".js-post-card-sns-user-mute-mute-card-btn",
};

class PostCardSnsUserMuteComponent {
  constructor(rootElement = document) {
    this._setEvent(rootElement);
  }

  _setEvent(rootElement) {
    this._setUnmuteCardEvent(rootElement);
    this._setMuteCardEvent(rootElement);
  }

  _setUnmuteCardEvent(rootElement) {
    rootElement.querySelectorAll(SELECTORS.card).forEach((card) => {
      const unmuteCardButton = card.querySelector(SELECTORS.unmuteCardButton);
      unmuteCardButton.addEventListener("click", (e) => {
        e.preventDefault();
        _toggleCard(card, false)
      });
    });
  }

  _setMuteCardEvent(rootElement) {
    rootElement.querySelectorAll(SELECTORS.muteCardButton).forEach((muteCardButton) => {
      const card = muteCardButton.closest(SELECTORS.card);
      muteCardButton.addEventListener("click", (e) => {
        e.preventDefault();
        _toggleCard(card, true);
      });
    });
  }
}

const _toggleCard = (card, isMute) => {
  const [info, caption, content] = [
    SELECTORS.info,
    SELECTORS.caption,
    SELECTORS.content,
  ].map((selector) => card.querySelector(selector));


  const isTwoColumnsMobile = _isTwoColumnsMobile(card);
  if (isMute) {
    isTwoColumnsMobile ? info.classList.remove("hidden") : info.classList.add("hidden", "md:block");
    caption.classList.remove("hidden");
    content.classList.add("hidden");
  } else {
    info.classList.add("hidden");
    info.classList.remove("md:block");
    caption.classList.add("hidden");
    content.classList.remove("hidden");
  }
};

const _toggleMuteCardButton = (card, isMute) => {
  const muteCardButton = card.querySelector(SELECTORS.muteCardButton);

  if (isMute) {
    muteCardButton.classList.remove("hidden");
  } else {
    muteCardButton.classList.add("hidden");
  }
};

const _isTwoColumnsMobile = (card) => {
  return card.dataset.isTwoColumnsMobile === "true";
};

const _getCardsByUserId = (userId, rootElement = document) => {
  return rootElement.querySelectorAll(`${SELECTORS.card}[data-user-id="${userId}"]`);
}

const muteByUserId = (userId, rootElement = document) => {
  _getCardsByUserId(userId, rootElement).forEach((card) => {
    _toggleCard(card, true)
    _toggleMuteCardButton(card, true);
  });
};

const unmuteByUserId = (userId, rootElement = document) => {
  _getCardsByUserId(userId, rootElement).forEach((card) => {
    _toggleCard(card, false)
    _toggleMuteCardButton(card, false);
  });
}

export default PostCardSnsUserMuteComponent;
export { muteByUserId, unmuteByUserId };
